export default __webpack_public_path__ + "static/media/pic3.6bc5608f.jpg";